import React, { useEffect, useState } from "react";
import "./unitDetailsForm.scss";
import FormComponent from "./CustomFormComponent";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  auditSaveData,
  editLoading,
  formId,
  savedLoading,
  submitLoading,
  unitDetailDisableButton,
  unitDetailsSubmitAtom,
  unitIndex,
} from "../../../store/atoms";
import { AuditData } from "../../data/AuditData";
import axios from "axios";
import { editData } from "../../../store/selectors";
import { getToken } from "../../auth/authConfig";
import { Box, CircularProgress, Modal } from "@mui/material";

const UnitDetailsForm = ({ handleOffsiteActivity, saveFormData, setUnitIndexValue, loading, apiDataLoaded }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const autditNumber = queryParams.get("auditNumber");
  // console.log("auditNumer hai na", autditNumber);
  // const unitIndexValue = useRecoilValue(unitIndex);
  const [saveData, setSaveValue] = useRecoilState(auditSaveData);

  console.log("gettind auditSaveData from recoil", saveData)
  // const [formData, setFormData] = useState(saveData?.unitDetails);
  // const editInfo = useRecoilValue(editData);

  const [activity, setActivity] = useRecoilState(unitDetailsSubmitAtom);
  const [formData, setFormData] = useState(saveData?.unitDetails || []);
  const saveButtonLoading = useRecoilValue(savedLoading);
  const submitButtonLoading = useRecoilValue(submitLoading);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [modalOpen, setModalOpen] = useRecoilState(editLoading);
  const [buttonsDisable, setButtonsDisable] = useRecoilState(
    unitDetailDisableButton
  );
  const [unitIndexes, setUnitIndexes] = useState([]);
  
  // Local state to track if form is valid for Next button
  const [isFormValid, setIsFormValid] = useState(false);


  // Function to validate if all required fields are filled
  const validateForm = (data) => {
    if (!data || data.length === 0) return false;
    
    const requiredFields = AuditData?.unitDetails?.filter(field => field.required) || [];
    
    return requiredFields.every(requiredField => {
      const fieldData = data.find(item => item.name === requiredField.name);
      if (!fieldData) return false;
      
      // Check if field has a value
      if (fieldData.value === null || fieldData.value === undefined || fieldData.value === '') {
        return false;
      }
      
      // For array values (like certifications), check if array has items
      if (Array.isArray(fieldData.value)) {
        return fieldData.value.length > 0;
      }
      
      return true;
    });
  };

  // Sync local formData with Recoil state - only on initial load, not override user changes
  useEffect(() => {
    // Only sync if we haven't loaded API data yet and Recoil has data
    if (!apiDataLoaded && saveData?.unitDetails && saveData.unitDetails.length > 0) {
      setFormData(saveData.unitDetails);
    }
  }, [saveData?.unitDetails, apiDataLoaded]);

  useEffect(() => {
    setSaveValue((prevState) => {
      const newState = {
        ...prevState,
        unitDetails: formData,
      };

      return newState;
    });
    
    // Validate form whenever formData changes
    const isValid = validateForm(formData);
    setIsFormValid(isValid);
  }, [formData]);

  
  
    const getUnitIndexes = async () => {
      try {
  
        const url = `${process.env.REACT_APP_SERVER_URL}/api/unitindexes`;
        const token = await getToken();
  
        const response = await axios.get(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
  
        if (response.status === 200) {
          const unitIndexes = response?.data?.unitIndexes;
          // converting unitIndexes into the lable and value format
          const formattedUnitIndexes = unitIndexes.map((item) => ({
                  value: item,
                  label: item,
          }))

          setUnitIndexes(formattedUnitIndexes);

          console.log("formatted unit indexes", formattedUnitIndexes)
          
        }
      } catch (error) {
        // setDataLoading(false);
        console.error("Error while calling the API:", error);
        // setloading(false);
      }
    };



  // Check if form is completed (for activity status)
  useEffect(() => {
    if (apiDataLoaded && saveData?.unitDetails) {
      // Check if there's activity status in the data
      const activityItem = saveData.unitDetails.find(item => item.name === "activity");
      if (activityItem?.value === 'completed') {
        setActivity(true);
      }
    }
  }, [apiDataLoaded, saveData?.unitDetails]);
  useEffect(() => {
    getUnitIndexes();
  },[])

  return (
    <>
      <div id="unitDetails-form">
        <FormComponent
          formData={formData || []}
          setFormData={setFormData}
          formFields={AuditData?.unitDetails}
          disabled={setButtonsDisable}
          option="unitDetails"
          unitIndexes = {unitIndexes}
          setUnitIndexValue={setUnitIndexValue}
        />
        <div className="bottom-container">
          <div className="required-text">
            Fields marked <span>*</span> are Required.
          </div>
          <div id="action-button-container">
            <>
              {!saveButtonLoading ? (
                <button
                  // disabled={saveButtonLoading}
                  onClick={() => saveFormData()}
                  className="action-btn"
                >
                  Save
                </button>
              ) : (
                <button
                  // disabled={saveButtonLoading}
                  className="action-btn"
                >
                  Loading...
                </button>
              )}

              <button
                onClick={() => {
                  // Just switch to offsite tab without calling save API
                  handleOffsiteActivity();
                }}
                className="action-btn"
                disabled={!isFormValid || buttonsDisable}
                style={{
                  opacity: (!isFormValid || buttonsDisable) ? 0.6 : 1,
                  cursor: (!isFormValid || buttonsDisable) ? 'not-allowed' : 'pointer'
                }}
              >
                Next
              </button>
            </>


          </div>
        </div>
      </div>
      <Modal open={loading}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // Full viewport height
            width: "100%",
            flexDirection: "column",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            backdropFilter: "blur(5px)", // Adding a blur effect for the background
            borderRadius: "10px", // Rounded corners
            padding: "20px",
          }}
        >
          <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
          <h3 style={{ color: "white", fontSize: "18px", fontWeight: "500" }}>
            Loading... Please wait
          </h3>
        </Box>
      </Modal>
    </>
  );
};

export default UnitDetailsForm;
